import { type AdminCharges, chargeCategory } from './chargeSummary'

const HEADER = [
  'period_start',
  'product',
  'product_type',
  'resource_type',
  'cluster_id',
  'pricing_group',
  'amount_usd',
]

function cell(value: string | null | undefined): string {
  const text = value ?? ''
  return /[",\n]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text
}

/** Every bucket of the report, one row each, with the product label the chart uses. */
export function chargesCsv(charges: AdminCharges): string {
  const rows = charges.buckets.map((bucket) =>
    [
      bucket.periodStart,
      chargeCategory(bucket),
      bucket.productType,
      bucket.resourceType,
      bucket.clusterId,
      bucket.pricingGroup,
      bucket.amountUsd,
    ]
      .map(cell)
      .join(','),
  )
  return [HEADER.join(','), ...rows].join('\n') + '\n'
}

export function downloadCsv(name: string, content: string) {
  const url = URL.createObjectURL(new Blob([content], { type: 'text/csv' }))
  const link = document.createElement('a')
  link.href = url
  link.download = name
  link.click()
  URL.revokeObjectURL(url)
}
